import React, { useEffect } from 'react'
import Header2 from '../../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useLanguage } from '../../contexts/LanguageContext'
import ServicesBanner from '../../components/haseeb/ServicesBanner'
import BannerImg from '../../assets/images/bannners/Branding.webp'
import ImageBorderStyleRight from '../../components/haseeb/ImageBorderStyleRight'
import ImageBorderStyleLeft from '../../components/haseeb/ImageBorderStyleLeft'
import Img1 from '../../assets/images/branding/Img1.webp'
import Img2 from '../../assets/images/branding/Img2.webp'
import Img3 from '../../assets/images/branding/Img3.webp'
import Img4 from '../../assets/images/branding/Img4.webp'
import { Link } from 'react-router-dom'
import MiddleBannerPrimary from '../../components/haseeb/MiddleBannerPrimary'
import MiddleBannerSecondary from '../../components/haseeb/MiddleBannerSecondary'
import { Col, Row } from 'reactstrap'
import { FaDotCircle } from 'react-icons/fa'

const Branding = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>software development & digital marketing agency in Germany - IT Junction </title>
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <ServicesBanner
    BannerImg={BannerImg}
    SubTitle={t('servicePages.branding.subtitle')}
    Title={t('servicePages.branding.title')}
    />
<section id='website-responsive' className="container-fluid px-0">
<div id='website-responsive'>
        <div className='right-padding8rem1 ps-lg-5 ps-4 py-lg-5 py-4'>
            <Row className=''>
                <Col lg='3' className='pb-5'>
                    <div className='pb-md-3 pb-lg-0 pb-3'>
                        <div className='d-flex align-items-center'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/healthcare-solutions' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.healthcareSolutions')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/branding/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-24 text-mulish fw-500 text-ss-primary'>
                                    {t('services.branding')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/graphic-designing' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.graphicDesigning')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/content-writing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.contentWriting')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/web-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.webDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/app-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.appDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/search-engine-optimization/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.seo')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/social-media-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.socialMediaMarketing')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/video-animation/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.videoAnimation')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/ppc-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.ppcMarketing')}
                            </span>
                                </Link>
                        </div>
                    </div>
                </Col>

                <Col className='ps-lg-4'>
                    <div className=''>
                        <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.branding.mainTitle')}
                            </h2>
                        </div>

                        <div className='me-lg-5'>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.branding.mainDescription')}
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>


    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center gy-4'>
        <div className="col-11 col-md-4">
          <img className='w-100' src={Img4} alt="" />
        </div>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.branding.collaborationTitle')}
             </div>
         </div>
         <div className='me-lg-5'>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.branding.collaborationDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>

    <MiddleBannerPrimary
    Title={t('servicePages.branding.visualIdentityTitle')}
    Para={t('servicePages.branding.visualIdentityDescription')}
    />

<section className="container-fluid py-4 py-lg-5">
      <div className='row justify-content-evenly align-items-start'>
      <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.branding.strategyTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.branding.strategyDescription')}
             </p>
        </div>
        </div>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.branding.voiceTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.branding.voiceDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>
    <MiddleBannerSecondary
    Title={t('servicePages.branding.regulationsTitle')}
    Para={t('servicePages.branding.regulationsDescription')}
    />
    <div className='pt-4 pt-lg-0'/>
    <ImageBorderStyleLeft
    Img={Img1}
    Title={t('servicePages.branding.markTerritoryTitle')}
    Para={t('servicePages.branding.markTerritoryDescription')}
    />
    
    <ImageBorderStyleRight
    Img={Img2}
    Title={t('servicePages.branding.knowConsumersTitle')}
    Para={t('servicePages.branding.knowConsumersDescription')}
    />

    <ImageBorderStyleLeft
    Img={Img3}
    Title={t('servicePages.branding.standOutTitle')}
    Para={t('servicePages.branding.standOutDescription')}
    />
    </section>
    </>
  )
}

export default Branding